import {
  linkToRetryPayment,
  linkToUpgrade,
  linkToUpgradeSubscriptionInfoiOS
} from "features/subscriptions/features/upgrades/routes/links";

import { linkToParentWhatIsPremiumPage } from "../links";

export function linkToParentUpgradeSubscription() {
  return linkToUpgrade(linkToParentWhatIsPremiumPage());
}

export function linkToParentUpgradeSubscriptionInfoiOS() {
  return linkToUpgradeSubscriptionInfoiOS(linkToParentWhatIsPremiumPage());
}

export function linkToRetryUpgradePayment(
  subscriptionId: string = ":subscriptionId"
) {
  return linkToRetryPayment(linkToParentWhatIsPremiumPage(), subscriptionId);
}

export { linkToParentWhatIsPremiumPage };
